import { useMutation } from "react-query"
import api from "../../client"

const deleteData = async (uuid: string | undefined) => {
    const { data } = await api.delete(
        `/address-book/${uuid}`,
    )
    return data
}

export const useAddressBookDelete = (uuid: string | undefined) => {
    return useMutation(() => {
        return deleteData(uuid)
    })
}
